<template>
    <AppLayout v-bind="appSharedData.getAppSidebarLayoutProps(pageMeta)">
        <template #right>
            <Button
                iconName="download"
                color="light"
            >
                Export
            </Button>
        </template>

        <div>
            <Table
                :isEmpty="
                    paginatedCompanyCustomerAggregates.numberOfRecords === 0
                "
            >
                <TableHead>
                    <TableHeadCell>Name</TableHeadCell>
                    <TableHeadCell>Email</TableHeadCell>
                    <TableHeadCell>Registered at</TableHeadCell>
                </TableHead>
                <TableBody>
                    <TableBodyRow
                        v-for="companyCustomerAggregate in localCompanyCustomerAggregates"
                        :key="companyCustomerAggregate.customer.id.value"
                    >
                        <TableBodyRowCell>
                            {{
                                companyCustomerAggregate.customer.getFullName()
                            }}
                        </TableBodyRowCell>
                        <TableBodyRowCell>
                            {{ companyCustomerAggregate.customer.email }}
                        </TableBodyRowCell>
                        <TableBodyRowCell>
                            {{
                                useDate().dateTime(
                                    companyCustomerAggregate.companyCustomer
                                        .createdAt,
                                )
                            }}
                        </TableBodyRowCell>
                    </TableBodyRow>
                </TableBody>

                <template #emptyState>
                    <TableEmptyState title="No customers yet." />
                </template>
            </Table>

            <div class="mt-4 text-sm text-gray-500">
                {{ paginatedCompanyCustomerAggregates.numberOfRecords }}
                customers found.
            </div>

            <div v-if="paginatedCompanyCustomerAggregates.numberOfPages > 1">
                <Pagination
                    as="a"
                    :searchResults="paginatedCompanyCustomerAggregates"
                    :url="RoutePathAppEnum.Customers"
                />
            </div>

            <div class="py-8"></div>
        </div>
    </AppLayout>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import AppLayout from '@/Shared/Layout/App/Sidebar/AppLayout.vue'
    import Table from '@/Shared/Component/Table/Table.vue'
    import TableHead from '@/Shared/Component/Table/TableHead.vue'
    import TableHeadCell from '@/Shared/Component/Table/TableHeadCell.vue'
    import TableBody from '@/Shared/Component/Table/TableBody.vue'
    import TableBodyRow from '@/Shared/Component/Table/TableBodyRow.vue'
    import TableBodyRowCell from '@/Shared/Component/Table/TableBodyRowCell.vue'
    import CompanyCustomerAggregate from '@/App/Company/Entity/CompanyCustomerAggregate'
    import useDate from '@/Shared/Hook/useDate'
    import Pagination from '@/Shared/Component/Pagination.vue'
    import TableEmptyState from '@/Shared/Component/Table/TableEmptyState.vue'
    import Button from '@/Shared/Component/Button.vue'
    import {
        type PageMeta,
        type PaginatedResultsType,
    } from '@/Shared/AutoGenerated/Main'
    import AppSharedData from '@/Shared/Entity/AppSharedData'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'

    interface IndexCustomersProps {
        pageMeta: PageMeta
        appSharedDataData: any
        paginatedCompanyCustomerAggregates: PaginatedResultsType
    }

    const props = defineProps<IndexCustomersProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
    const localCompanyCustomerAggregates = ref<CompanyCustomerAggregate[]>(
        CompanyCustomerAggregate.hydrateMultiple(
            props.paginatedCompanyCustomerAggregates.records,
        ),
    )
</script>
